import { render } from "./StarIcon.vue?vue&type=template&id=37cbc5f1"
import script from "./StarIcon.vue?vue&type=script&lang=js"
export * from "./StarIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__